import { render } from "./LesAmis.vue?vue&type=template&id=2ecb3628&scoped=true&ts=true"
import script from "./LesAmis.vue?vue&type=script&lang=ts"
export * from "./LesAmis.vue?vue&type=script&lang=ts"

import "./LesAmis.vue?vue&type=style&index=0&id=2ecb3628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecb3628"]])

export default __exports__